<div mat-dialog-title>
    <h1>{{ 'address_book_management.address_book_search_modal.title' | translate }}</h1>
    <button id="{{idPrefix}}btn.x" mat-button class="close close-btn" tabindex="-1" [mat-dialog-close]="">
        <mat-icon class="dr-material-icon">clear</mat-icon>
    </button>
</div>

<div mat-dialog-content>

    <search-input class="search-input" label="{{'address_book_management.address_book_search_modal.input.search'}}" (textChange)="doSearch($event)"></search-input>

    <ag-grid-angular
            style="height: 50vh;"
            id="{{idPrefix}}overview"
            class="ag-theme-material"
            #agGridCaseWidget
            [rowData]="rowData"
            [gridOptions]="gridOptions">
    </ag-grid-angular>

</div>

<div mat-dialog-actions align="center">

    <div class="col-sm-6">
        <button id="{{idPrefix}}btn.ok"
                mat-raised-button class="full-width" color="accent"
                [disabled]="!hasSelection()"
                (click)="ok()">
            {{ 'common.btn.ok' | translate }}
        </button>
    </div>

    <div class="col-sm-6 no-gutters pl-0">
        <button mat-stroked-button
                color="primary"
                id="create_case_dialog.btn.cancel"
                class="full-width"
                (click)="close()">
            {{ 'common.btn.cancel' | translate }}
        </button>
    </div>

</div>
